import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { PriceFormatted } from '@estee/elc-formatters';
import { Body2 } from '@estee/elc-typography';

import { ProductPriceFormatted } from '../common/ProductPriceFormatted';
import { classes } from '../../utils/Classes';
import { ISku } from '../../interfaces/IVto';
import { VTO_PRICE_FORMATTED, VTO_PRODUCT_SIZE } from '../../constants/DataTestIdAttributes';
import { TaxIncluded } from '../common/TaxIncluded';
import { config } from '@estee/elc-service';

interface IVtoShadeInfoRightContainer {
    selectedSku: ISku;
    hasProductSize?: boolean;
    hideProductPricePerUnit?: boolean;
    hideProductPrice: boolean;
    config: {
        showIncludeTaxLabel: boolean;
    };
}

const Wrapper = styled.div`
    float: right;
    [dir='rtl'] & {
        float: left;
    }
`;

const productPriceClassNames = classes('vto-price');
const productSizeClassNames = classes('vto-product-size');
const shadeInfoRightContainerClassNames = classes('vto-shade-info-right-container');

export const VtoShadeInfoRightContainer = config(['showIncludeTaxLabel'])(
    observer(
        ({
            selectedSku,
            hasProductSize,
            hideProductPricePerUnit,
            hideProductPrice,
            config: { showIncludeTaxLabel }
        }: IVtoShadeInfoRightContainer) => {
            const {
                selectedSize,
                formattedOriginalPrice,
                formattedPrice,
                formattedPricePerUnit
            } = selectedSku;
            const selectedSizeValue =
                hasProductSize && selectedSize ? selectedSize.value : undefined;

            return (
                <Wrapper className={shadeInfoRightContainerClassNames}>
                    {!hideProductPrice && (
                        <>
                            {showIncludeTaxLabel && <TaxIncluded />}
                            <div className={productPriceClassNames}>
                                <ProductPriceFormatted
                                    formattedPrice={formattedPrice}
                                    formattedOriginalPrice={formattedOriginalPrice}
                                />
                                {formattedPricePerUnit && !hideProductPricePerUnit && (
                                    <PriceFormatted
                                        data-test-id={VTO_PRICE_FORMATTED}
                                        formattedPrice={formattedPricePerUnit}
                                    />
                                )}
                            </div>
                        </>
                    )}
                    {selectedSizeValue && (
                        <Body2 className={productSizeClassNames} data-test-id={VTO_PRODUCT_SIZE}>
                            {selectedSizeValue}
                        </Body2>
                    )}
                </Wrapper>
            );
        }
    )
);
